import React from 'react'; 
import NewsArticles from './NewsArticles';
import { Link } from 'react-router-dom';
import WithConsumer from '../../context/WithConsumer';

const News = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
	const ctxDoRender = () => context.doRender;
    const doRender = ctxDoRender();
    
    let ctxPrevSlug = () => context.prevSlug;
	let prev = ctxPrevSlug();
    
    if (post && doRender) {

	    let pageClass = 'c-page' + post.slug;
		
		if (pageLoaded) {
		    pageClass = pageClass + ' state-page-loaded';
	    }
	    		
		return (
			<>
					
				<div className={pageClass}>
					<div className="c-page__inner c-page__inner--no-space">
					
						<div className="c-page__header c-page__block--load-effect">
																								
							<h1 className="c-page__header__heading" dangerouslySetInnerHTML={{__html: 'News'}}></h1>		
															
						</div>
								
						{post.news &&
							<NewsArticles articles={post.news}></NewsArticles>
						}
					</div>
				</div>
				
			</>
		)
					
	} else {
		return null;
	}
};
export default WithConsumer(News);